import React from "react";
import { useNavigate } from "react-router-dom";

const BookingSuccess = ({ data = {} }) => {
  const navigate = useNavigate();
  return (
    <div>
      <div className="mt-4 mb-5">
        <div className=" d-flex justify-content-between align-items-center w-100 p-10 testimonials-wrapper">
          <p>
            Your booking is successful. Check your email for the session
            instructions and your Start OTP. Please read it carefully.
          </p>
        </div>
      </div>
      {data?.isBooking && (
        <div className=" mt-4 mb-5">
          <div className=" d-flex justify-content-end align-items-center w-100 p-10 testimonials-wrapper">
            <div>
              <button
                type="button"
                className="btn btn-primary prime-btn"
                onClick={() => navigate("../myspace/schedule")}
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingSuccess;
